// extracted by mini-css-extract-plugin
export default {"section":"Form_section__TkwbQ"};